export function initNewsletterCta() {
  const element = document.getElementById("js-newsletter-cta");
  const closeButton = document.getElementById("js-newsletter-cta-close");

  if (!element || !closeButton) {
    return;
  }

  const initCta = () => {
    setTimeout(() => {
      element.classList.add("active");
    }, 10000);

    element.addEventListener("click", () => {
      element.classList.remove("active");
      localStorage.setItem("newsletterCta", new Date().toISOString());
    });

    closeButton.addEventListener("click", () => {
      element.classList.remove("active");
      localStorage.setItem("newsletterCta", new Date().toISOString());
    });
  };

  const startDateString = localStorage.getItem("newsletterCta");

  if (startDateString) {
    const startDate = new Date(startDateString);
    const currentDate = new Date();

    const differenceInMilliseconds =
      currentDate.getTime() - startDate.getTime();
    const millisecondsInWeek = 1000 * 60 * 60 * 24 * 7;
    const differenceInWeeks = differenceInMilliseconds / millisecondsInWeek;

    if (differenceInWeeks >= 3) {
      localStorage.removeItem("newsletterCta");
      initCta();
    }
  } else {
    initCta();
  }
}
